/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  {
    smalltext: 'Click to select wallet',
    i18n: 'Click to select wallet',
  },
  {
    url: '/add-account',
    name: 'Add wallet',
    slug: 'add-account',
    i18n: 'Add wallet',
    meta: {
      type: 'account-menu',
    },
  },
  // {
  //   url: "/add-account",
  //   name: "Add wallet",
  //   slug: "add-account",
  //   i18n: "Add wallet",
  //   icon: "PlusCircleIcon",
  //   meta: {
  //     type: 'add-wallet',
  //     hideOnHover: true,
  //   },
  // },
  {
    header: ' ',
    i18n: ' ',
  },
  {
    url: '/home',
    name: 'Home',
    slug: 'home',
    /*icon: "HomeIcon",*/
    icon: 'ActivityIcon',
    meta: {
      type: 'when-active-account',
    },
  },
  {
    url: '/payments',
    name: 'Payments',
    slug: 'payments',
    icon: 'CreditCardIcon',
    meta: {
      type: 'when-active-account',
    },
  },

  //HIDE*
  // {
  //   url: "/payouts",
  //   name: "Withdrawals",
  //   slug: "withdrawals",
  //   icon: "DollarSignIcon",
  //   meta: {
  //     type: 'when-active-account'
  //   },
  // },

  // {
  //   url: "/settings",
  //   name: "Wallet settings",
  //   slug: "settings",
  //   icon: "SettingsIcon",
  //   meta: {
  //     type: 'when-active-account'
  //   },
  // },
  {
    url: '/payment-link',
    name: 'Invoicing',
    slug: 'invoicing',
    icon: 'FileMinusIcon',
    meta: {
      type: 'when-active-account',
    },
  },
  /*{
    url: "/create-invoice",
    name: "Send invoice",
    slug: "dashboard",
    icon: "HomeIcon",
    meta: {
      type: 'when-active-account'
    },
  },*/

  {
    header: ' ',
    i18n: ' ',
  },
];
